// src/pages/Reports/ReceiptReports/ReceiptReportPage.jsx
import ReceiptReportBase from "./ReceiptReportBase";

export default function ReceiptReportPage() {
  return <ReceiptReportBase scope="all" />;
}
